import React, { useState, useEffect } from 'react';
import { ArrowRight as ArrowRightIcon, Leaf as LeafIcon } from 'lucide-react';
import { motion } from 'framer-motion';
const urgencyItems = [{
  image: 'https://cdn.magicpatterns.com/uploads/8morGjpgJNNbZ9Ky3h3k3H/Desayunos_4.jpg',
  alt: 'Eggs, avocado, berries, and seeded yogurt',
  text: '🔥 LAUNCH PRICE ENDS SOON — Get 50 recipes + 5 bonuses for $19.97 before it goes up to $47.00'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/6Pz6RmXdU2tshAiFVyCDe2/Desayunos_5.jpg',
  alt: 'Strawberry and blueberry yogurt parfait',
  text: "⏰ This price expires soon — grab it before it's gone"
}, {
  image: 'https://cdn.magicpatterns.com/uploads/2252cxXo9BdfVTicaFto2E/Desayunos_2.jpg',
  alt: 'Raspberry yogurt parfait held in a hand',
  text: '✨ 21 Days of Radiant Mornings — More Energy · Less Bloating · Flatter Belly in 21 days'
}, {
  image: 'https://cdn.magicpatterns.com/uploads/ezcCqfPxTks7P9KcjKJE7p/Desayunos_1.jpg',
  alt: 'Yogurt bowl with banana, berries, and granola',
  text: '🛡️ 7-Day Money-Back Guarantee — Zero risk, all reward'
}];
export function Hero() {
  const [timeLeft, setTimeLeft] = useState('24:00:00');
  useEffect(() => {
    const getOrCreateDeadline = () => {
      const stored = localStorage.getItem('offer_deadline');
      if (stored) {
        const parsed = parseInt(stored, 10);
        if (parsed > Date.now()) {
          return parsed;
        }
      }
      const newDeadline = Date.now() + 24 * 60 * 60 * 1000;
      localStorage.setItem('offer_deadline', newDeadline.toString());
      return newDeadline;
    };
    let deadline = getOrCreateDeadline();
    const updateTimer = () => {
      const now = Date.now();
      let diff = deadline - now;
      if (diff <= 0) {
        deadline = Date.now() + 24 * 60 * 60 * 1000;
        localStorage.setItem('offer_deadline', deadline.toString());
        diff = deadline - now;
      }
      const totalSeconds = Math.floor(diff / 1000);
      const h = String(Math.floor(totalSeconds / 3600)).padStart(2, '0');
      const m = String(Math.floor(totalSeconds % 3600 / 60)).padStart(2, '0');
      const s = String(totalSeconds % 60).padStart(2, '0');
      setTimeLeft(`${h}:${m}:${s}`);
    };
    updateTimer();
    const interval = setInterval(updateTimer, 1000);
    return () => clearInterval(interval);
  }, []);
  return <>
      <div className="sticky top-0 z-50 flex h-14 items-center overflow-hidden border-b border-cream/15 bg-forest text-sm font-bold text-cream shadow-lg" data-id="element-73" data-mp="1azumdhg3ytyy">
        <div className="min-w-0 flex-1 overflow-hidden" aria-label="Limited-time offer details" data-id="element-74" data-mp="112px38qyuidx">
          <div className="urgency-marquee-track flex w-max" data-id="element-75" data-mp="x1w8ed5p8zjz">
            {[false, true].map(isDuplicate => <div key={isDuplicate ? 'duplicate' : 'primary'} className="flex shrink-0 items-center" aria-hidden={isDuplicate} data-id="element-76" data-mp="3lu02z1erz4zq">
                {urgencyItems.map(({
              image,
              alt,
              text
            }, index) => <div key={text} className="flex shrink-0 items-center whitespace-nowrap pr-10" data-id="element-77" data-mp="21amwtbz2vwne" data-mpi={index}>
                    <img src={image} alt={isDuplicate ? '' : alt} className="urgency-marquee-image mx-3 h-9 w-9 rounded-md object-cover" style={{
                animationDelay: `-${index * 1.2}s`
              }} data-id="element-78" data-mp="268fypstcm4hv" />
                    <span data-id="element-79" data-mp="2p0qn6hn99zwg">{text}</span>
                  </div>)}
              </div>)}
          </div>
        </div>

        <div className="flex h-full shrink-0 items-center border-l border-cream/20 bg-forest px-3 sm:px-4" data-id="element-80" data-mp="2tyaeoj8ys96c">
          <span className="hidden text-cream/75 sm:inline" data-id="element-81" data-mp="uo0uu4cjcyr6">Expires in:</span>
          <span className="text-cream/75 sm:hidden" data-id="element-82" data-mp="zmlvg4vp9kg5">Expires:</span>
          <time className="ml-2 rounded bg-terracotta px-2 py-1 font-mono text-sm font-extrabold tabular-nums text-white" aria-label={`Offer expires in ${timeLeft}`} data-id="element-83" data-mp="4b46fr58o0ie">
            {timeLeft}
          </time>
        </div>
      </div>

      <header className="border-b border-forest/10 bg-cream" data-id="element-84" data-mp="e8sbb9wk6oea">
        <div className="mx-auto flex max-w-6xl items-center justify-between px-5 py-5 lg:px-8" data-id="element-85" data-mp="9bifnciktgi0">
          <a href="#top" className="flex items-center gap-2 text-lg font-bold tracking-tight text-forest" aria-label="Edad Radiante home" data-id="element-86" data-mp="3hrbxbuon8y0n">
            <span className="flex h-8 w-8 items-center justify-center rounded-full bg-terracotta text-white" data-id="element-87" data-mp="3rglmb1o6y0kj">
              <LeafIcon size={17} data-id="element-88" data-mp="3moc3s6peo2sa" />
            </span>
            Edad Radiante
          </a>
          <a href="#offer" className="hidden text-sm font-bold text-forest underline decoration-terracotta decoration-2 underline-offset-4 sm:block" data-id="element-89" data-mp="2yyzjaaomo8ao">
            Get the guide
          </a>
        </div>
      </header>

      <main id="top" className="bg-cream" data-id="element-90" data-mp="19gkn521fo5ni">
        <section className="mx-auto grid max-w-6xl items-center gap-9 px-5 py-12 sm:py-14 lg:grid-cols-[1.08fr_.92fr] lg:gap-14 lg:px-8 lg:py-16" data-id="element-91" data-mp="1e9nfx7ydzb2n">
          <motion.div initial={{
          opacity: 0,
          y: 16
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5
        }} data-id="element-92" data-mp="ziek2h3w4th2">
            <div className="mb-6 flex items-center gap-3 text-terracotta" data-id="element-93" data-mp="1x6x3n1aqvapp">
              <span className="h-px w-8 bg-terracotta/60" aria-hidden="true" data-id="element-94" data-mp="1j98e3g5qffeb" />
              <LeafIcon size={19} strokeWidth={2.5} aria-hidden="true" data-id="element-95" data-mp="1n9sdkqds2v3m" />
              <p className="text-xl font-extrabold uppercase tracking-[0.08em] sm:text-2xl" data-id="element-96" data-mp="1nc50lhye7vnj">
                21 Days of Radiant Mornings
              </p>
            </div>

            <h1 className="max-w-2xl font-serif text-3xl leading-[1.16] tracking-tight text-forest sm:text-4xl lg:text-[2.65rem]" data-id="element-97" data-mp="bwgh50kclerh">
              <span className="block" data-id="element-98" data-mp="2ejepnug8ex1f">
                You sleep 8 hours and still wake up exhausted.
              </span>
              <span className="mt-3 block" data-id="element-99" data-mp="24rhbcetxfoyh">
                You eat well and still gain weight.
              </span>
              <span className="mt-3 block" data-id="element-100" data-mp="1ztfum0jz41q6">
                Your body isn&apos;t broken — it just needs a breakfast plan
                built for menopause.
              </span>
            </h1>

            <p className="mt-6 max-w-xl text-base leading-7 text-forest/80 sm:text-lg sm:leading-8" data-id="element-101" data-mp="1qrq3kvu074sx">
              21 Days of Radiant Mornings is the hormone-friendly breakfast plan
              that wakes up your energy, reduces bloating, and brings you back
              to yourself — no impossible diets, no starving, no guilt.
            </p>

            <a href="https://pay.hotmart.com/Q106802782G?checkoutMode=10" className="mt-8 inline-flex w-full items-center justify-center gap-3 rounded-full bg-terracotta px-6 py-5 text-center text-sm font-extrabold tracking-wide text-white shadow-lg shadow-terracotta/20 transition hover:bg-[#a84a35] focus:outline-none focus:ring-4 focus:ring-terracotta/30 sm:w-auto" data-id="element-102" data-mp="3g4tk944jmxri">
              YES — START MY 21 DAYS OF RADIANT MORNINGS{' '}
              <ArrowRightIcon size={18} data-id="element-103" data-mp="1acg5l0crckb" />
            </a>
            <p className="mt-4 text-sm font-semibold leading-6 text-forest/75" data-id="element-104" data-mp="30q95nrktnd35">
              ✓ Instant access · ✓ Secure checkout · ✓ 7-day money-back
              guarantee
            </p>
          </motion.div>

          <motion.figure initial={{
          opacity: 0,
          scale: 0.97
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.6,
          delay: 0.1
        }} className="relative mx-auto w-full max-w-[28rem] lg:max-w-[34rem]" data-id="element-105" data-mp="39qe95qmw9rc1">
            <div className="absolute -left-3 -top-3 h-full w-full rounded-[2rem] border border-terracotta/45 sm:-left-4 sm:-top-4" aria-hidden="true" data-id="element-106" data-mp="1f32cabjd41f8" />
            <img className="relative w-full rounded-[2rem] object-cover shadow-2xl shadow-forest/20" src="https://cdn.magicpatterns.com/uploads/41q2RhL89Muqepjafhrmhb/Imagen_Modulo_1.png" alt="21 Days of Radiant Mornings digital guide" data-id="element-107" data-mp="1otwyxh0it317" />
          </motion.figure>
        </section>
      </main>
    </>;
}